import { render } from "./SimpleBarChart.vue?vue&type=template&id=42876040&scoped=true"
import script from "./SimpleBarChart.vue?vue&type=script&lang=js"
export * from "./SimpleBarChart.vue?vue&type=script&lang=js"

import "./SimpleBarChart.vue?vue&type=style&index=0&id=42876040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42876040"]])

export default __exports__